export default __webpack_public_path__ + "static/main-638f14cedd9889cd72de40aa1ce7176a.jpeg";